import { useEffect, useState } from 'react'
import { Table, message, InputNumber } from 'antd'
import { useNavModel } from '@/model/navModel'
import { useModel } from '../model'
import useGlobalModel from '@/model/globalModel'
import { YhTableSort } from '@/components/YhTableSort'
import { commonService } from '@/service/common'
import YhTootip from '@/components/YhTootip'
import { service } from '../service'
import { globalPrompt } from '@/components/message'
import { SettingOutlined } from '@ant-design/icons'

const sortKey = 'commoditiesList'

export function DataTable() {
    const { dataSource, setDataSource, pgCfg, updateEditFormVal, loadData, columnsSetVisible, setColumnsSetVisible, orders, loading } = useModel()
    const {
        user: { shopId, shopName, branch },
    } = useGlobalModel()
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => [])

    useEffect(() => {
        setDataSource([])
        loadData()
        getColumns()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const onEdit = (record) => {
        let supplierEditKey = '2-1-1'
        let isFindNav = findNav(supplierEditKey)
        if (!isFindNav) {
            addNav(supplierEditKey, { id: record?.id, mode: 'edit' })
            updateEditFormVal(record)
            window.sessionStorage.setItem('commoditiesDetails', JSON.stringify(record))
        } else {
            globalPrompt('modal', {
                title: '商品跳转详情',
                type: 'warning',
                text: '您还有商品详情未保存，是否跳转',
                okText: '跳转未保存页',
                onOk: () => selectNav(isFindNav ? isFindNav.id : ''),
                cancelText: '打开新页签',
                onCancel: () => {
                    switchNavState(supplierEditKey, { id: record?.id, mode: 'edit' })
                    updateEditFormVal(record)
                    window.sessionStorage.setItem('commoditiesDetails', JSON.stringify(record))
                },
            })
        }
    }

    const getRegularColumns = [
        {
            title: (
                <>
                    <span>
                        <SettingOutlined
                            onClick={() => {
                                setColumnsSetVisible(true)
                            }}
                        />
                    </span>
                    <span>序号</span>
                </>
            ),
            width: 80,
            fixed: 'left',
            align: 'center',
            render: (t, r, i) => i + 1,
        },
    ]
    const defaultColumns = [
        {
            title: '分支编码',
            width: 120,
            dataIndex: 'branch',
            render: (text) => <YhTootip text={text} style={{ width: '120px' }} />,
            isSet: true,
        },
        {
            title: '门店名称',
            width: 120,
            dataIndex: 'shopName',
            isSet: true,
            render: (text) => <YhTootip text={text} style={{ width: '120px' }} />,
        },
        {
            title: '商品编码',
            width: 140,
            dataIndex: 'materialCode',
            sorter: true,
            isSet: true,
            render: (t, r) => (
                <YhTootip
                    onClick={() => {
                        onEdit(r)
                    }}
                    text={r.materialCode}
                    style={{ width: '140px', color: '#4165E3', cursor: 'pointer' }}
                />
            ),
        },
        {
            title: '商品名称',
            width: 200,
            dataIndex: 'materialName',
            sorter: true,
            isSet: true,
            render: (text) => <YhTootip text={text} style={{ width: '200px' }} />,
        },
        {
            title: '商品分类',
            width: 120,
            dataIndex: 'typeName',
            sorter: true,
            isSet: true,
            render: (text) => <YhTootip text={text} style={{ width: '120px' }} />,
        },
        {
            title: '商品品牌',
            width: 120,
            dataIndex: 'brandName',
            sorter: true,
            isSet: true,
            render: (text) => <YhTootip text={text} style={{ width: '120px' }} />,
        },
        {
            title: '库存上限',
            width: 120,
            dataIndex: 'limitUpper',
            sorter: true,
            isSet: true,
            render: (text, record) => (
                <InputNumber
                    value={text}
                    style={{ width: '120px' }}
                    name={'limitUpper' + record.id}
                    onBlur={(value) => {
                        handleInventoryBlur(value, record, 'UP')
                    }}
                />
            ),
        },
        {
            title: '库存下限',
            width: 120,
            dataIndex: 'limitLower',
            sorter: true,
            isSet: true,
            render: (text, record) => (
                <InputNumber
                    value={text}
                    style={{ width: '120px' }}
                    name={'limitLower' + record.id}
                    onBlur={(value) => {
                        handleInventoryBlur(value, record, 'LOW')
                    }}
                />
            ),
        },
    ]

    const [columns, setColumns] = useState<any[]>([])

    const getColumns = () => {
        commonService.userCustomizeConfigOne(sortKey).then((res) => {
            if (!res.retData) {
                setColumns([...getRegularColumns, ...defaultColumns])
            } else {
                let newColumns: any[] = [...getRegularColumns]
                let data = JSON.parse(res.retData.val)
                data.forEach((element) => {
                    if (element.isShow) {
                        newColumns.push({ ...defaultColumns.find((i) => i.dataIndex === element.key), sorter: element.isSort })
                    }
                })
                setColumns(newColumns)
            }
        })
    }

    const onSuccess = () => {
        setColumnsSetVisible(false)
        getColumns()
    }

    const onChange = (pagination, filters, sorter) => {
        if (sorter.field) {
            if (sorter.order) {
                orders.current = [{ column: sorter.field, asc: sorter.order === 'ascend' }]
            } else {
                orders.current = []
            }
            loadData()
        }
    }

    const handleInventoryBlur = async (value, item, type: string) => {
        await service.listUpdate({
            id: item.id,
            code: item.materialCode,
            sourceApp: branch,
            shopId,
            shopName,
            limitUpper: type === 'UP' ? value.target.value : item.limitUpper,
            limitLower: type === 'LOW' ? value.target.value : item.limitLower,
        })
        message.success('修改成功')
        loadData()
    }

    return (
        <>
            <Table
                rowKey={(record) => record.id}
                onChange={onChange}
                columns={columns}
                dataSource={dataSource}
                loading={loading}
                pagination={{
                    ...pgCfg,
                    position: ['bottomRight'],
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    },
                    showSizeChanger: true,
                }}
                bordered
                scroll={{ x: 'max-content', y: 'calc(100vh - 380px)' }}
            />
            <YhTableSort
                sortKey={sortKey}
                visible={columnsSetVisible}
                setVisible={setColumnsSetVisible}
                defaultColumns={defaultColumns}
                onSuccess={onSuccess}
            />
        </>
    )
}
